import { render } from "./BuyLpModal.vue?vue&type=template&id=b1e7e6d4"
import script from "./BuyLpModal.vue?vue&type=script&lang=ts"
export * from "./BuyLpModal.vue?vue&type=script&lang=ts"
script.render = render

export default script